import React from 'react';
import { Assistant } from '@/types';
import { SuggestedPrompts } from '@/components/assistant';
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';
import { getIconColorFromAssistant } from '@/utils/colorUtils';

interface EmptyStateProps {
    assistant: Assistant;
    onPromptClick: (prompt: string) => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ assistant, onPromptClick }) => {
    const iconColor = getIconColorFromAssistant(
        assistant.bgGradient,
        assistant.accentColor
    );

    return (
        <div className="flex flex-col items-center justify-center min-h-[40vh] sm:min-h-[50vh] animate-fade-in px-2 sm:px-4">
            <div className={`p-2 sm:p-3 md:p-4 rounded-full bg-gradient-to-br ${assistant.bgGradient}`}>
                {renderAssistantIcon({
                    assistant,
                    iconColor: iconColor,
                    useGradientColor: true,
                    size: 'lg'
                })}
            </div>
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-1.5 sm:mb-2 mt-2 sm:mt-3 md:mt-4 text-center">
                Hi! I'm {assistant.name}
            </h2>
            <p className="text-gray-200 mb-4 sm:mb-6 md:mb-8 text-center max-w-md text-xs sm:text-sm md:text-base px-1 sm:px-2">
                {assistant.description}. <br className="hidden sm:inline" /> How can I help you today?
            </p>

            <SuggestedPrompts
                prompts={assistant.suggestedPrompts}
                assistant={assistant}
                onPromptClick={onPromptClick}
            />
        </div>
    );
};